import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ErrorModalForm } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-error",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./error.component.html",
})
export class ErrorComponent extends Modalable {
	modalTitleLang: string = "how_can_we_help"

	errorModalForm = new ErrorModalForm() //the object that holds the field values (and is saved)
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		email: { email: null },
		announcement: { not_empty: null },
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.errorModalForm,
			this.errors,
			this.validationFields
		)
	}

	ngOnInit() {
		//when called to open tries to retrieve the user's email and phone from storage
		if (sessionStorage.getItem("cliniqData")) {
			//if user is logged in (and has their data in storage)
			let cliniqData = JSON.parse(sessionStorage.getItem("cliniqData") || "")
			if (cliniqData) {
				this.errorModalForm.email = cliniqData.email
				this.errorModalForm.phone = cliniqData.phone
			}
		}
	}

	async sendErrorEmail() {
		//send form values to the api
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		//this.errorModalForm.announcement += this.errorModalForm.email + ' ' + this.errorModalForm.phone;	//unify all fields (except subject)
		this.onClose.emit()
		await this.apiService.post(
			"report_bug",
			this.errorModalForm,
			"subject,announcement,email,phone"
		)
		this.modalService.openToast("sent_successfully") //toast a success message
	}
}
